// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"25d0f396","29":"5165e612","34":"7ffe36e5","63":"d3ec067e","324":"7283a5e3","395":"04e66971","538":"6641b138","598":"1ce7c857","670":"0a79aa9e","938":"3375ffd4","976":"37c25cb9","981":"a65be3dc"}[chunkId] + ".chunk.js";
};